import React from 'react';

function About() {
  return (
    <div className="section about-section light-bg reveal">
      <div className="content about-grid">
        <div className="about-image-stack">
          <img
            src="https://images.unsplash.com/photo-1533460004989-cef01064af7e?auto=format&fit=crop&w=1000&q=82"
            alt="Agricultural worker inspecting livestock feed on a farm"
          />
          <div className="about-badge">Field-led nutrition thinking</div>
        </div>
        <div>
          <p className="eyebrow">About Zyvora</p>
          <h2>Premium livestock nutrition with grounded agricultural judgment.</h2>
          <p>
            Zyvora Life Sciences 9 focuses on cattle and buffalo feed supplements that balance modern formulation discipline with the practical expectations of farmers, veterinarians, dealers, and bulk buyers.
          </p>
          <div className="about-values">
            <article><h3>Vision</h3><p>To become a trusted livestock nutrition partner for healthier animals and stronger rural livelihoods.</p></article>
            <article><h3>Mission</h3><p>To deliver safe, effective, and accessible feed supplements through clear formulation and farmer-first support.</p></article>
            <article><h3>Leadership</h3><p>Guided by Mr. Narendra Pal Singh, combining public service discipline with full-time farming experience.</p></article>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
